(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();

		this.isProductPage = true;
		this.activeIndex = 0;
		this.touchStartX = null;
		this.touchStartY = null;
		this.items = Array.from(this.querySelectorAll(".product-media-modal__item"));
		this.prevButton = this.querySelector(".product-media-modal__nav--prev");
		this.nextButton = this.querySelector(".product-media-modal__nav--next");
		this.currentCounter = this.querySelector("[data-product-media-current]");
		this.totalCounter = this.querySelector("[data-product-media-total]");
		this.content = this.querySelector(".product-media-modal__content");
		this.zoomScale = 1;
		this.zoomX = 0;
		this.zoomY = 0;
		this.zoomPointers = new Map();
		this.panStart = null;
		this.pinchStart = null;
		this.lastTapTime = 0;

		this.prevButton?.addEventListener("click", () => this.setActiveIndex(this.activeIndex - 1));
		this.nextButton?.addEventListener("click", () => this.setActiveIndex(this.activeIndex + 1));

		this.querySelectorAll(".product__media-subitem").forEach((thumbnail) => {
			thumbnail.addEventListener("click", (event) => {
				event.preventDefault();
				const mediaId = thumbnail.getAttribute("data-media-sub-id");
				const nextIndex = this.items.findIndex((item) => item.getAttribute("data-media-modal-id") === mediaId);
				if (nextIndex > -1) this.setActiveIndex(nextIndex);
			});
		});

		this.content?.addEventListener("pointerdown", this.handlePointerDown.bind(this));
		this.content?.addEventListener("pointermove", this.handlePointerMove.bind(this));
		this.content?.addEventListener("pointerup", this.handlePointerUp.bind(this));
		this.content?.addEventListener("pointercancel", this.handlePointerEnd.bind(this));
		this.content?.addEventListener("lostpointercapture", this.handlePointerEnd.bind(this));
		this.content?.addEventListener("dblclick", (event) => {
			if (event.target.closest(".product-media-modal__nav, .product-media-modal__toggle")) return;
			this.toggleZoom(event.clientX, event.clientY);
		});

		this.addEventListener("keydown", (event) => {
			if (event.key === "ArrowLeft") {
				event.preventDefault();
				this.setActiveIndex(this.activeIndex - 1);
			}
			if (event.key === "ArrowRight") {
				event.preventDefault();
				this.setActiveIndex(this.activeIndex + 1);
			}
		});
	}

	hide() {
		super.hide(this.isProductPage);
		document.body.classList.remove("product-media-modal-open");
		this.resetZoom();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		document.body.classList.add("product-media-modal-open");
		this.showActiveMedia();		
	}

	showActiveMedia() {
		const mediaId = this.openedBy?.getAttribute("data-media-id");
		const nextIndex = this.items.findIndex((item) => {
			return item.getAttribute("data-media-modal-id")?.endsWith(`-${mediaId}`);
		});
		this.setActiveIndex(nextIndex > -1 ? nextIndex : 0);
	}

	setActiveIndex(index) {
		if (!this.items.length) return;
		const nextIndex = (index + this.items.length) % this.items.length;
		this.resetZoom();
		this.activeIndex = nextIndex;

		this.items.forEach((item, itemIndex) => {
			const isActive = itemIndex === nextIndex;
			item.classList.toggle("active", isActive);
			item.setAttribute("aria-hidden", String(!isActive));
			if (!isActive) return;
			const playableMedia = item.querySelector("deferred-media, product-model");
			if (playableMedia?.nodeName == "DEFERRED-MEDIA" && playableMedia?.querySelector("template")?.content?.querySelector(".js-youtube")) {
				playableMedia.loadContent();
			}
		});

		this.querySelectorAll(".product__media-subitem").forEach((thumbnail) => {
			const isActive = thumbnail.getAttribute("data-media-sub-id") === this.items[nextIndex].getAttribute("data-media-modal-id");
			thumbnail.classList.toggle("active", isActive);
		});

		if (this.currentCounter) this.currentCounter.textContent = String(nextIndex + 1);
		if (this.totalCounter) this.totalCounter.textContent = String(this.items.length);
	}

	getActiveImage() {
		return this.items[this.activeIndex]?.querySelector("img");
	}

	handlePointerDown(event) {
		if (event.target.closest(".product-media-modal__nav, .product-media-modal__toggle")) return;
		this.content?.setPointerCapture?.(event.pointerId);
		this.zoomPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
		this.touchStartX = event.clientX;
		this.touchStartY = event.clientY;

		if (this.zoomPointers.size === 2) {
			const points = Array.from(this.zoomPointers.values());
			this.pinchStart = {
				distance: this.getDistance(points[0], points[1]),
				scale: this.zoomScale,
			};
			return;
		}

		if (this.zoomScale > 1) {
			event.preventDefault();
			this.panStart = {
				x: event.clientX,
				y: event.clientY,
				zoomX: this.zoomX,
				zoomY: this.zoomY,
			};
		}
	}

	handlePointerMove(event) {
		if (!this.zoomPointers.has(event.pointerId)) return;
		this.zoomPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

		if (this.zoomPointers.size === 2 && this.pinchStart) {
			event.preventDefault();
			const points = Array.from(this.zoomPointers.values());
			const nextScale = this.pinchStart.scale * (this.getDistance(points[0], points[1]) / this.pinchStart.distance);
			this.setZoom(nextScale, this.zoomX, this.zoomY);
			return;
		}

		if (this.zoomScale > 1 && this.panStart) {
			event.preventDefault();
			this.setZoom(
				this.zoomScale,
				this.panStart.zoomX + event.clientX - this.panStart.x,
				this.panStart.zoomY + event.clientY - this.panStart.y
			);
		}
	}

	handlePointerUp(event) {
		const deltaX = event.clientX - this.touchStartX;
		const deltaY = event.clientY - this.touchStartY;
		const moved = Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8;
		this.handlePointerEnd(event);

		if (this.zoomScale > 1) {
			if (!moved) {
				const now = Date.now();
				if (now - this.lastTapTime < 320) {
					this.resetZoom();
					this.lastTapTime = 0;
				} else {
					this.lastTapTime = now;
				}
			}
			return;
		}

		if (!moved) {
			const now = Date.now();
			if (now - this.lastTapTime < 320) {
				this.toggleZoom(event.clientX, event.clientY);
				this.lastTapTime = 0;
			} else {
				this.lastTapTime = now;
			}
			return;
		}

		if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return;
		this.setActiveIndex(this.activeIndex + (deltaX < 0 ? 1 : -1));
	}

	handlePointerEnd(event) {
		this.zoomPointers.delete(event.pointerId);
		this.panStart = null;
		if (this.zoomPointers.size < 2) this.pinchStart = null;
	}

	toggleZoom(clientX, clientY) {
		if (this.zoomScale > 1) {
			this.resetZoom();
			return;
		}

		const image = this.getActiveImage();
		const rect = image?.getBoundingClientRect();
		if (!rect) return;
		const offsetX = (rect.left + rect.width / 2 - clientX) * 1.15;
		const offsetY = (rect.top + rect.height / 2 - clientY) * 1.15;
		this.setZoom(2.1, offsetX, offsetY);
	}

	setZoom(scale, x = 0, y = 0) {
		this.zoomScale = Math.min(Math.max(scale, 1), 2.6);
		const clamped = this.clampPan(x, y);
		this.zoomX = clamped.x;
		this.zoomY = clamped.y;
		this.applyZoom();
	}

	resetZoom() {
		this.zoomScale = 1;
		this.zoomX = 0;
		this.zoomY = 0;
		this.zoomPointers.clear();
		this.panStart = null;
		this.pinchStart = null;
		this.applyZoom();
	}

	applyZoom() {
		const image = this.getActiveImage();
		this.content?.classList.toggle("is-zoomed", this.zoomScale > 1);
		if (!image) return;
		image.style.transform = this.zoomScale > 1
			? `translate3d(${this.zoomX}px, ${this.zoomY}px, 0) scale(${this.zoomScale})`
			: "";
		image.style.cursor = this.zoomScale > 1 ? "grab" : "";
	}

	clampPan(x, y) {
		const image = this.getActiveImage();
		const content = this.content;
		if (!image || !content || this.zoomScale <= 1) return { x: 0, y: 0 };
		const imageWidth = image.offsetWidth * this.zoomScale;
		const imageHeight = image.offsetHeight * this.zoomScale;
		const maxX = Math.max(0, (imageWidth - content.clientWidth) / 2);
		const maxY = Math.max(0, (imageHeight - content.clientHeight) / 2);
		return {
			x: Math.min(Math.max(x, -maxX), maxX),
			y: Math.min(Math.max(y, -maxY), maxY),
		};
	}

	getDistance(pointA, pointB) {
		return Math.hypot(pointA.x - pointB.x, pointA.y - pointB.y);
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();
})();
